import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-skeleton',
    templateUrl: './skeleton.component.html',
    styleUrls: ['./skeleton.component.scss'],
    standalone: false
})
export class SkeletonComponent {
  @Input()
  style = '';

  // TODO: Add a count of how many parts/'bones'(?) to repeat
  @Input()
  count = 1;
  Array = Array;

  constructor() {}
}
